export const normalizeText = (text: string): string => {
  if (!text) return '';
  return text
    .normalize('NFD')
    .replace(/[\p{Diacritic}]/gu, '')
    .replace(/[^\p{L}\p{N}\s@._-]/gu, '')
    .replace(/\s+/gu, ' ')
    .trim()
    .toLowerCase();
};

export const reverseNormalizedName = (name: string): string => {
  if (!name) return '';
  const normalized = normalizeText(name);
  const words = normalized.split(' ').filter((word) => word.length > 0);
  return words.reverse().join(' ');
};
